import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DataService {
  url = environment.url;
  firmwareUrl = environment.firmwareUrl;

  private apiUrl = "https://k2-clustering-partcount.azurewebsites.net/api/partcount";
  // private apiUrl = "http://192.168.1.179:7071/api/partcount";
  private apiKey = "bxdtvcycVRS2vEuyIDsN1HIHbkeoasCGPChgKYm7Aw-TAzFuXBIzfA==";

  private plantapiUrl = "https://k2plant.azurewebsites.net/api/";
  // private plantapiUrl = "http://192.168.1.179:9090/api/";
  private plantapiKey = "1kXJQA-fmFNMC47P6paQQeXTZ5eamh6Eb4pSvYmNRt91AzFuJOEW4w==";

  private machineapiUrl = "https://k2machines.azurewebsites.net/api/";
  // private machineapiUrl = "http://192.168.1.179:7071/api/";
  private machineapiKey = "wa7ZUpdqFNui2XmAdouh3Jd4IC8fbV5UB5P36ke_PMCWAzFu8bfToQ=="

  private interlockapiUrl = "https://interlocking.azurewebsites.net/api/";
  // private interlockapiUrl = "http://192.168.1.179:7071/api/";
  private interlockapiKey = "wYqjMxaSDZuIi59ePT9Etjzc4jVkBN2Qxh1Chezapww0AzFuTKQvVA=="

  private chartapiUrl = "https://k2-oee-prod.azurewebsites.net/api/device_gantt_chart_date?code=Heb_fi-GyL1JLSoJ6cQN5YkqELvYg-EvxZB1gn0frIqcAzFum5-CDA==";
  private chartapiKey = "AoThSCnmA2IYtXSZY4y1U8zmAMw5qGmdfCX-KMgok7fNAzFuSeIoGw==";

  private report_auditapiUrl = "https://k2-reports-audit.azurewebsites.net/api/";
  // private report_auditapiUrl = "http://192.168.1.179:7071/api/";
  private report_auditapiKey = "1UKQqD4Qu2TpOG7f4lkVOp6Dy7fHaEbrn2PPmpM0eHucAzFu9fNS7A==";

  
  private chatbot_apiUrl = "https://k2chartbot-aghmcnhya4g0dchk.centralindia-01.azurewebsites.net/api/";
  // private report_auditapiUrl = "http://192.168.1.179:7071/api/";
  private chatbot_apiKey = "myY8UMMO3ZIQVQnEd2RySH-rdiqQuj3qdxklIv_5nfH-AzFuLQCwaA==";

  //getCustomerList
  // private customerListUrl='https://k2machines.azurewebsites.net/api/customers';
  private customerListKey = "kBc1ekKSynwrRtecCjApZlhbQdrwlDvH2XxjK5v-49w-AzFuoTmp3A=="
  private saveSuperCustomerApi = environment.superUserUrl

  constructor(private http: HttpClient) { }

  headers = new HttpHeaders({
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  });

  get(params: any) {
    return this.http.get(this.url + params);
  }

  post(params: any, data: any) {
    return this.http.post(this.url + params, data);
  }

  put(params: any, data: any) {
    return this.http.put(this.url + params, data);
  }

  delete(params: any) {
    return this.http.delete(this.url + params);
  }

  upload(data: any) {
    return this.http.put(this.url + "upload", data);
  }

  certCreate(params: any, data: any) {
    return this.http.post(this.url + params, data);
  }

  getFirmware(params: any) {
    return this.http.get(this.firmwareUrl + params);
  }

  postFirmware(params: any, data: any) {
    return this.http.post(this.firmwareUrl + params, data);
  }

  deleteFirmware(params: any) {
    return this.http.delete(this.firmwareUrl + params);
  }

  publishDataFirmware(params: any) {
    return this.http.post(this.firmwareUrl + params, {});
  }

  partCount(param:any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-functions-key": this.apiKey,
    });
    return this.http.post(this.apiUrl, param, { headers });
  }

  history_chart(param:any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-functions-key": this.chartapiKey,
    });
    return this.http.post(this.chartapiUrl, param, { headers });
  }

  plantApi(param: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-functions-key': this.plantapiKey,
    });
    return this.http.post(`${this.plantapiUrl}${param}`, body, { headers });
  }

  machineApi(param: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-functions-key': this.machineapiKey,
    });
    return this.http.post(`${this.machineapiUrl}${param}`, body, { headers });
  }

  machineDeleteApi(param: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-functions-key': this.machineapiKey,
    });
    return this.http.request('DELETE', `${this.machineapiUrl}${param}`, { headers, body });
  }

  reportApi(param: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-functions-key': this.report_auditapiKey,
    });
    return this.http.post(`${this.report_auditapiUrl}${param}`, body, { headers });
  }
  
  chatbotApi(param: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-functions-key': this.chatbot_apiKey,
    });
    return this.http.post(`${this.chatbot_apiUrl}${param}`, body, { headers });
  }
  

  interlockApi(param: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-functions-key': this.interlockapiKey,
    });
    return this.http.post(`${this.interlockapiUrl}${param}`, body, { headers });
  }

  getCustomerList(param: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-functions-key': this.customerListKey,
    });
    return this.http.get(`${this.machineapiUrl}${param}`, { headers })
  }
  saveSuperCustomer(param: string, body: any): Observable<any> {

    return this.http.post(`${this.url}api${param}`, body)
  }
  updateSuperCustomer(param: string, body: any): Observable<any> {

    return this.http.put(`${this.url}api${param}`, body)
  }
  getSuperCustomer(param: string): Observable<any> {

    return this.http.get(`${this.url}api${param}`)
  }
  deleteSuperCustomer(param: string): Observable<any> {

    return this.http.delete(`${this.url}api${param}`)
  }
  getSuperCustomerDeviceById(param: string): Observable<any> {

    return this.http.get(`${this.url}api${param}`)
  }
}
